import { connect } from 'react-redux';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { ApplicationState } from 'app/types-store';
import { mapPropsFromTranslations } from 'app/infrastructure/redux/container-factory';
import { translations } from './constants';
import { UnlockCaseConfig, UnlockCaseArgs } from './types';
import get from 'lodash/get';

export const withUnlocking = (config: UnlockCaseConfig) => (component: any, uiEngineProps?: ConnectedComponentProps) => {
  const path = uiEngineProps?.hostProps()?.statePath;
  let textPath = path;

  if (Array.isArray(path)) {
    textPath = path[0];
  }

  const mapStateToProps = (state: ApplicationState) => ({
    unlockCaseTranslate: mapPropsFromTranslations(translations, get(state, textPath)?.texts)
  });

  const mapDispatchToProps = () => ({
    getLockedBy: config.getLockedBy,
    discardUnlockCase: async (args: UnlockCaseArgs, translate) =>
      config.discardUnlockCase({ caseId: uiEngineProps?.caseNumber, ...args }, translate),
    choosePersonUnlockCase: async (args: UnlockCaseArgs, translate) =>
      config.choosePersonUnlockCase({ caseId: uiEngineProps?.caseNumber, ...args }, translate),
    getPersonOptions: config.getPersonOptions
  });

  return connect(mapStateToProps, mapDispatchToProps)(component);
};

export const withUnlockingFromTextPath = (config: UnlockCaseConfig, textPath: string | string[], caseId: number) =>
  (component: any) => {
    const mapStateToProps = (state: ApplicationState) => ({
      unlockCaseTranslate: mapPropsFromTranslations(translations, get(state, textPath)?.texts)
    });

    const mapDispatchToProps = () => ({
      getLockedBy: config.getLockedBy,
      discardUnlockCase: async (args: UnlockCaseArgs, translate) =>
        config.discardUnlockCase({ ...args }, translate),
      choosePersonUnlockCase: async (args: UnlockCaseArgs, translate) =>
        config.choosePersonUnlockCase({ caseId, ...args }, translate),
      getPersonOptions: config.getPersonOptions
    });

    return connect(mapStateToProps, mapDispatchToProps)(component);
  };
